import { render, staticRenderFns } from "./MessageVariablesSettings.vue?vue&type=template&id=7212e8fc&scoped=true"
import script from "./MessageVariablesSettings.vue?vue&type=script&lang=ts"
export * from "./MessageVariablesSettings.vue?vue&type=script&lang=ts"
import style0 from "./MessageVariablesSettings.vue?vue&type=style&index=0&id=7212e8fc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7212e8fc",
  null
  
)

export default component.exports